
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { LabelLayout } from "@/utils/label-layout/label-layout";
import { EpsonPrint, IEpsonTemplate, IEpsonTemplateField } from "@/utils/electron/electron-print-epson";

export default Vue.extend({
	data(){
		return {
			templates: [] as IEpsonTemplate[],
			loading: false,
			error: "",
			defaultsMessage: ""
		};
	},
	props: {
		layout: {
			type: Object as ()=>LabelLayout,
			required: true
		},
	},
	computed: {
		templateItems():ISelectItem<string>[] {
			let items = this.templates.map(t=>({text: t.name, value: t.id} as ISelectItem<string>));
			let current = this.layout.Epson.Template;
			if (current && !items.find(i=>i.value == current)) {
				items.unshift({text: current, value: current});
			}
			return items;
		},
		selectedTemplate():IEpsonTemplate | null {
			return this.templates.find(t=>t.id == this.layout.Epson.Template) || null;
		},
		modelName():string {
			try {
				return this.layout.getModel().getName();
			} catch (err) {
				return "";
			}
		},
		defaultMapping():{[key:string]:string} | null {
			if (!this.selectedTemplate || !this.modelName) return null;
			let mapping = (this.selectedTemplate.mappings || {})[this.modelName];
			if (!mapping || Object.keys(mapping).length == 0) return null;
			return mapping;
		},
		qualityItems():ISelectItem<string>[] {
			return [
				{text: "Max speed", value: "D"},
				{text: "Speed", value: "S"},
				{text: "Normal", value: "N"},
				{text: "Quality", value: "Q"},
				{text: "Max quality", value: "M"},
			];
		}
	},
	methods: {
		async loadTemplates(){
			this.loading = true;
			this.error = "";
			try {
				this.templates = await EpsonPrint.getTemplates(this.layout.Epson.ServiceUrl);
				if (this.templates.length == 0) {
					this.error = this.$ct("epson-no-templates") as string;
				} else if (!this.layout.Epson.Template) {
					this.layout.Epson.Template = this.templates[0].id;
				}
			} catch (err:any) {
				this.error = err?.message || `${err}`;
			}
			this.loading = false;
		},
		fillDefaults(){
			if (!this.defaultMapping) return;
			let filled = 0;
			let skipped = 0;
			for (let key of Object.keys(this.defaultMapping)) {
				if (this.layout.Epson.Fields[key]) {
					skipped++;
					continue;
				}
				this.$set(this.layout.Epson.Fields, key, this.defaultMapping[key]);
				filled++;
			}
			this.defaultsMessage = this.$ct("epson-fill-defaults-done", {filled, skipped}) as string;
		},
		getField(key:string):string {
			return this.layout.Epson.Fields[key] || "";
		},
		setField(key:string, value:string){
			if (!value) {
				this.$delete(this.layout.Epson.Fields, key);
				return;
			}
			this.$set(this.layout.Epson.Fields, key, value);
		},
		placeholderFor(field:IEpsonTemplateField):string {
			if (field.kind == "image") return "${value.Images && value.Images[0] ? value.Images[0].getFileUrl() : ''}";
			return "${value.Sku}";
		}
	},
	mounted(){
		if (this.layout.Epson.ServiceUrl) {
			this.loadTemplates();
		}
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
